import { Row, Col, Button, Tooltip, Modal, Badge } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import DataTable from "../../../../common/DataTable";
import {
  APPOINTMENT_LIST_ON_VIEW_SCHEDULE,
  ScheduleList_HEADERS,
} from "./../actions/constant";
import dayjs from "dayjs"; // <-- Add this at the top

import "jquery-confirm";

import Snackbar from "../../../../common/Snackbar";
import { ToastContainer, toast } from "react-toastify";

import {
  FetchScheduleList,
  FetchDoctorScheduleDetails,
  CancelDoctorScheduleScheduleId,
  ValidateAppointmentByScheduleId,
  FetchStakeholderContactByUserId,
} from "../../../../services/DoctorScheduleAPI"; // <-- Added Cancel API
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import "jquery";
import { MANAGE_SCHEDULE_ACTIONS } from "../../../../common/EventConstant";
import AccordionComponent from "../../../../common/Accordion";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import { RequestForRescheduleAppointment } from "../../../../services/AppointmentsAPI";

declare global {
  interface JQueryStatic {
    confirm: (options: any) => void;
    alert: (message: string) => void;
  }

  interface JQuery {
    confirm: (options: any) => void;
    alert: (message: string) => void;
  }
}

export {};

interface ViewScheduleProps {
  qmeDoctorContactId: any;
  year: any;
  month: any;
  hospital: any;
  onRowSelect: any;
  onRadioSelect?: (row: any) => void; // <-- new prop
  subTab: any;
  QMEDoctor: any;
}

const ScheduleList: React.FC<ViewScheduleProps> = ({
  qmeDoctorContactId,
  year,
  month,
  hospital,
  onRowSelect,
  subTab,
  QMEDoctor,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [scheduleData, setScheduleData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [selectedRowRadio, setSelectedRowRadio] = useState<any>(null);
  const [action, setAction] = useState<string | null>(null);
  const [scheduleDetails, setScheduleDetails] = useState<any[]>([]);
  const [stakeholderContactId, setStakeholderContactId] = useState<
    number | null
  >(null);

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );
  const isCancelBulk = allowedFeatures.has(MANAGE_SCHEDULE_ACTIONS.CANCEL_BULK);
  const isButtonEnabled =
    selectedRow?.original?.scheduleId !== undefined && isCancelBulk;
  useEffect(() => {
    if (QMEDoctor) {
      setStakeholderContactId(QMEDoctor);
    }
  }, [QMEDoctor]);
  // useEffect(() => {
  //   const fetchContactId = async () => {
  //     try {
  //       const response = await FetchStakeholderContactByUserId(loggedInUserid);

  //       if (response?.isSuccess && response.result?.stakeholderContactId) {
  //         setStakeholderContactId(response.result.stakeholderContactId);
  //         console.log(
  //           response.result.stakeholderContactId,
  //           "response.result.stakeholderContactId"
  //         );
  //       } else {
  //         console.warn("No Stakeholder Contact ID found.");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching stakeholder contact ID:", error);
  //     }
  //   };

  //   fetchContactId();
  // }, [loggedInUserid]);
  useEffect(() => {
    fetchScheduleData();
  }, [stakeholderContactId, month, year, hospital]);

  useEffect(() => {
    fetchScheduleData();
  }, [subTab]);

  const fetchScheduleData = async () => {
    try {
      setLoading(true);
      const payload = {
        qmeDoctorContactId: stakeholderContactId,
        year,
        month,
        medicareProviderIds: hospital,
      };
      const response = await FetchScheduleList(payload);
      if (response?.isSuccess) {
        const formatted = response.result
          .filter((item: any) => item.status !== "Cancelled") // Exclude cancelled
          .map((item: any) => ({
            select: "", // Placeholder for radio column
            scheduleId: item.scheduleId,
            scheduleType:
              item.scheduleType === "Availability" ? (
                <span style={{ color: "#32CD32", fontWeight: "500" }}>
                  Available
                </span>
              ) : (
                <span className="text-danger">Unavailable</span>
              ),
            scheduleMode:
              item.scheduleMode === "Month" ? "Month" : "Date Range",
            selecteddaterangemonth:
              item.scheduleMode === "Month"
                ? item.selectedMonths
                : `${dayjs(item.startDate).format("MM/DD/YYYY")} - ${dayjs(
                    item.endDate,
                  ).format("MM/DD/YYYY")}`,

            selectedays: Array.isArray(item.selectedWeekdays)
              ? item.selectedWeekdays.join(", ")
              : item.selectedWeekdays || "",

            timeslots:
              item.scheduleType === "Availability" &&
              item.startTime &&
              item.endTime
                ? `${dayjs(item.startTime).format("hh:mm A")} - ${dayjs(
                    item.endTime,
                  ).format("hh:mm A")}`
                : "N/A",

            medicareProviderName:
              item.scheduleType === "Availability" && item.medicareProviderName
                ? item.medicareProviderName
                : "N/A",

            actions: { View: "View" },
            original: item, // For selection reference,
            isReadOnly: item.isReadOnly,
          }));
        // console.log(formatted, "formattedformatted");

        setScheduleData(formatted);
        setSelectedRow(null);
      } else {
        setScheduleData([]);
        setSelectedRow(null);
      }
    } catch (err) {
      console.error("Error fetching schedule data", err);
    } finally {
      setLoading(false);
    }
  };

  const handleRowSelection = async (rowData: any) => {
    const selected = rowData.original;
    const scheduleId = selected?.scheduleId;
    if (!scheduleId) return;

    setSelectedRow(selected);

    try {
      const detailsResponse = await FetchDoctorScheduleDetails(scheduleId);

      if (detailsResponse?.isSuccess) {
        const enrichedRow = {
          ...selected,
          scheduleDetails: detailsResponse.result, // attach the fetched data
        };

        // Pass the enriched data to parent
        onRowSelect(enrichedRow);
      } else {
        console.warn("No details found for this schedule.");
        onRowSelect({ ...selected, scheduleDetails: [] }); // fallback
      }
    } catch (error) {
      console.error("Failed to fetch schedule details:", error);
      onRowSelect({ ...selected, scheduleDetails: [] }); // fallback
    }
  };
  const handleRadioSelect = async (rowData: any) => {
    const selected = rowData.original; //  Real data
    const scheduleId = selected?.scheduleId;

    if (!scheduleId) return;

    try {
      const detailsResponse = await FetchDoctorScheduleDetails(scheduleId);

      const enrichedRow = {
        ...rowData,
        original: {
          ...selected,
          scheduleDetails: detailsResponse?.isSuccess
            ? detailsResponse.result
            : [],
        },
      };

      setSelectedRow(enrichedRow); //  Now button should enable
    } catch (error) {
      setSelectedRow({
        ...rowData,
        original: { ...selected, scheduleDetails: [] },
      });
    }
  };

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [appointmentCount, setAppointmentCount] = useState<number>(0);
  const [selectedScheduleId, setSelectedScheduleId] = useState<string | null>(
    null,
  );

  const [appointmentList, setAppointmentList] = useState<any[]>([]);
  // const handleCancelClick = async () => {
  //   if (!selectedRow) {
  //     toast.error("Please select a schedule to cancel.");
  //     return;
  //   }

  //   const scheduleId = selectedRow.original?.scheduleId;

  //   if (!scheduleId) {
  //     toast.error("Invalid schedule ID.");
  //     return;
  //   }

  //   try {
  //     const validationResponse = await ValidateAppointmentByScheduleId(
  //       scheduleId.toString()
  //     );

  //     if (!validationResponse?.isSuccess) {
  //       toast.error("Failed to validate appointments for this schedule.");
  //       return;
  //     }

  //     const appointmentCount = validationResponse.result?.appointmentCount || 0;

  //     $.confirm({
  //       title: "Are you sure you want to cancel this schedule?",
  //       content: `
  //         <div>
  //           <p style="color: red; font-weight: normal;" class="text-center text-danger">
  //             ${appointmentCount} Appointment(s) scheduled during this time span will be cancelled!
  //           </p>
  //           <label>Please specify the reason for cancellation</label>
  //           <textarea id="cancel-reason" class="form-control" placeholder="Reason" style="font-size:13px;min-height:80px"></textarea>
  //         </div>
  //       `,
  //       buttons: {
  //         cancel: {
  //           text: "<span class='material-icons mx-2'>close</span> Cancel",
  //           btnClass: "  d-flex align-items-center btn btn-outline-info",
  //         },
  //         confirm: {
  //           text: "<span class='material-icons mx-2'>check</span> Confirm",
  //           btnClass: "d-flex align-items-center btn btn-primary",
  //           action: async function (this: any) {
  //             const reason = this.$content.find("#cancel-reason").val() || ""; // ✅ Empty string if not provided

  //             try {
  //               const response = await CancelDoctorScheduleScheduleId(
  //                 scheduleId.toString(),
  //                 reason
  //               );

  //               if (response?.isSuccess) {
  //                 setSnackbarMessage("Schedule cancelled successfully.");
  //                 setError("success");
  //                 setSnackbarOpen(true);
  //                 // toast.success("Schedule cancelled successfully!");
  //                 setSelectedRow(null);
  //                 fetchScheduleData();
  //               } else {
  //                 setSnackbarMessage(
  //                   response?.message || "Failed to cancel schedule"
  //                 );
  //                 setError("error");
  //                 setSnackbarOpen(true);
  //               }
  //             } catch (error: any) {
  //               setSnackbarMessage(error.message || "An error occurred");
  //             }
  //           },
  //         },
  //       },
  //     });
  //   } catch (err: any) {
  //     toast.error("Failed to fetch appointment count.");
  //     console.error(err);
  //   }
  // };

  const handleCancelClick = async () => {
    try {
      const scheduleId = selectedRow.original?.scheduleId;

      const validationResponse = await ValidateAppointmentByScheduleId(
        scheduleId.toString(),
      );

      // Assuming validationResponse.result is an array

      const appointmentCount = validationResponse.length;

      setSelectedScheduleId(scheduleId);
      setAppointmentCount(appointmentCount);
      setAppointmentList(validationResponse);
      setShowCancelModal(true);
    } catch (err: any) {
      toast.error("Failed to fetch appointment count.");
      console.error(err);
    }
  };

  const handleConfirmCancelButton = async () => {
    if (!selectedScheduleId) return;

    try {
      setLoading(true);
      if (appointmentCount > 0) {
        const subjectQmeScheduleIds = appointmentList
          .map((item) => item.subjectQmeScheduleId)
          .join(",");

        const payload = {
          subjectQmeScheduleIds: subjectQmeScheduleIds, // e.g., "241,234"
          startDate: null,
          startTime: null,

          providerAddress: null,
          note: cancelReason,
        };

        let Requestresponse = await RequestForRescheduleAppointment(payload);

        if (Requestresponse?.data?.subjectQmeScheduleId) {
          const response = await CancelDoctorScheduleScheduleId(
            selectedScheduleId,
            cancelReason,
          );

          if (response?.isSuccess) {
            setSnackbarMessage("Schedule cancelled successfully.");
            setError("success");
            setSnackbarOpen(true);
            setShowCancelModal(false);
            setCancelReason("");
            setSelectedScheduleId(null);
            fetchScheduleData();
            setLoading(false);
          } else {
            setSnackbarMessage(
              response?.message || "Failed to cancel schedule",
            );
            setError("error");
            setSnackbarOpen(true);
            setLoading(false);
          }
        }
      } else {
        const response = await CancelDoctorScheduleScheduleId(
          selectedScheduleId,
          cancelReason,
        );

        if (response?.isSuccess) {
          setSnackbarMessage("Schedule cancelled successfully.");
          setError("success");
          setSnackbarOpen(true);
          setShowCancelModal(false);
          setCancelReason("");
          setSelectedScheduleId(null);
          fetchScheduleData();
          setLoading(false);
        } else {
          setSnackbarMessage(response?.message || "Failed to cancel schedule");
          setError("error");
          setSnackbarOpen(true);
          setLoading(false);
        }
      }
    } catch (error: any) {
      setSnackbarMessage(error.message || "An error occurred");
      setError("error");
      setSnackbarOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    //console.log("Selected Row:", selectedRow);
  }, [selectedRow]);

  const [appointmentlistKey, setAppointmentlistKey] = useState<string | null>(
    null,
  );

  const appointmentListAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={appointmentlistKey}
      onSelect={(key) => setAppointmentlistKey(key as string)}
    />
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 col mb-3">
        <h3 className="mr-2 me-auto">List</h3>
        <Snackbar
          message={snackbarMessage}
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        <Button
          className="d-flex align-items-center btn-outline-danger bg-none mx-2 btn"
          disabled={!isButtonEnabled}
          style={!selectedRow ? { pointerEvents: "none" } : {}}
          onClick={handleCancelClick} // Trigger the cancel action on click
        >
          <span className="material-icons me-2">close</span> Cancel Schedule
        </Button>
      </div>

      <Row>
        <Col>
          <DataTable
            headers={ScheduleList_HEADERS}
            rows={scheduleData}
            onRadioSelect={handleRadioSelect} // For radio button clicks ✅
            radioSelection={true}
            selectedRow={selectedRow}
            key={scheduleData.length}
            onAction={handleRowSelection}
            // isviewschedule="View Schedule"
          />
        </Col>
      </Row>
      <Modal
        show={showCancelModal}
        onHide={() => {
          setShowCancelModal(false);
          setCancelReason("");
          setAppointmentlistKey(null);
        }}
        centered
        size="xl"
      >
        <Modal.Body className="text-center">
          {/* Header Text */}
          <h5 className="fw-bold mb-2">
            Are you sure you want to add unavailability?
          </h5>

          {/* Red Warning Text */}
          {appointmentCount > 0 && (
            <p className="text-danger mb-4" style={{ fontSize: "14px" }}>
              {appointmentCount} Appointment(s) scheduled during this time span
              will be requested for reschedule
            </p>
          )}
          {/* Reason Textarea (using MultilineTextBox) */}
          <Row className="mt-3 px-3">
            <Col sm={12}>
              <MultilineTextBox
                label="Reason"
                name="reason"
                value={cancelReason ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.startsWith(" ")) return;
                  value = value?.trimStart();
                  value = value.replace(/ {2,}/g, " ");
                  setCancelReason(value);
                }}
                maxLength={100}
              />
            </Col>
          </Row>

          {/* Accordion shown only if appointmentCount > 0 */}
          <Row className="mt-3 px-3">
            <Col sm={12}>
              {appointmentCount > 0 &&
                appointmentListAccordion([
                  {
                    title: (
                      <div className="d-flex align-items-center">
                        <span>Appointment List</span>
                        {!appointmentlistKey && (
                          <Badge
                            pill
                            bg="primary"
                            className="ms-2 primary-badge"
                          >
                            {appointmentCount}
                          </Badge>
                        )}
                      </div>
                    ),
                    content: (
                      <>
                        <Row className="mt-3 px-3">
                          <DataTable
                            headers={APPOINTMENT_LIST_ON_VIEW_SCHEDULE}
                            rows={appointmentList}
                          />
                        </Row>
                      </>
                    ),
                  },
                ])}
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            onClick={() => {
              setShowCancelModal(false);
              setCancelReason("");
              setAppointmentlistKey(null);
            }}
            className="d-flex align-items-center"
          >
            <span className="material-icons me-1">close</span> Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleConfirmCancelButton}
            className="d-flex align-items-center ms-2"
          >
            <span className="material-icons me-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default ScheduleList;
